import { useContext } from "react"
import { VideoQuizConfigContext } from "../components/VideoQuizConfigProvider";

export default function useVideoQuizConfig() {
    const context = useContext(VideoQuizConfigContext)

    if (!context) {
        throw new Error("Debes utilizar el hook useVideoQuizConfig dentro del VideoQuizConfigProvider")
    }

    return context
}